/* eslint-disable no-case-declarations */
/* eslint-disable eqeqeq */
export const types = {
  POST: 'CREATE_SESSION',
  PUT: 'UPDATE_SESSION',
  DELETE: 'DELETE_SESSION',
  RESET: 'RESET_SESSION',
};


export const sessionReducer = (state = {}, action) => {
  switch (action.type) {
    case types.POST:
      return {
        ...state,
        ...action.payload,
      };
    case types.PUT:
      return state.map((child) => (child.id == action.payload.id ? action.payload : child));
    case types.DELETE:
      const newValues = { ...state };
      delete newValues[action.payload];
      return newValues;
    case types.RESET:
      return {};
    default:
      return state;
  }
};
